import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, Checkbox, Button, Icon } from 'antd'
import { activateModules } from '../../actions/ClientAction'

export class ActivationModules extends Component {
  constructor(props) {
    super(props)

    this.state = {
      commentsAndVersions: false,
      MFA: false,
      BunkeyHost: false,
      sistemasDeGrupos: false,
      // DES-196/DES-205 — defaults espejo de RightsConstants.MODULE_DEFAULTS
      // en bunkey.objects: useRights apagado, blockDownloadOnExpiredRights
      // prendido (para no apagar en silencio un bloqueo ya vivo en producción).
      useRights: false,
      blockDownloadOnExpiredRights: true
    }
  }
  componentDidMount() {
    const { /*modulesWorkClient, isIndividualComponent,*/ modules } = this.props
    // const statusModules = []
    // const sendModules = []

    // if (!isIndividualComponent) {
    //   if (modules) {
    //     modules.forEach(permission => {
    //       if (permission.name === 'commentsAndVersions') {
    //         statusModules.push({ commentsAndVersions: permission.activate })
    //         sendModules.push({ name: 'commentsAndVersions', activate: permission.activate })
    //       } else {
    //         statusModules.push({ commentsAndVersions: false })
    //         sendModules.push({ name: 'commentsAndVersions', activate: false })
    //       }

    //     });
    //   }
    // } else {
    //   modulesWorkClient.forEach(permission => {
    //     if (permission.name === 'commentsAndVersions' && permission.activate === true) {
    //       statusModules.push({ commentsAndVersions: true })
    //       sendModules.push({ name: 'commentsAndVersions', activate: permission.activate })
    //     } else {
    //       statusModules.push({ commentsAndVersions: false })
    //       sendModules.push({ name: 'commentsAndVersions', activate: false })
    //     }
    //   });
    // }
    // this.setState(
    //   ...statusModules
    // )

    this.setState({
      commentsAndVersions:
        modules && modules.find((m) => m.name === 'commentsAndVersions')
          ? modules.find((m) => m.name === 'commentsAndVersions').activate
          : false,
      MFA:
        modules && modules.find((m) => m.name === 'MFA')
          ? modules.find((m) => m.name === 'MFA').activate
          : false,
      BunkeyHost:
        modules && modules.find((m) => m.name === 'BunkeyHost')
          ? modules.find((m) => m.name === 'BunkeyHost').activate
          : false,
      sistemasDeGrupos:
        modules && modules.find((m) => m.name === 'sistemasDeGrupos')
          ? modules.find((m) => m.name === 'sistemasDeGrupos').activate
          : false,
      useRights:
        modules && modules.find((m) => m.name === 'useRights')
          ? modules.find((m) => m.name === 'useRights').activate
          : false,
      blockDownloadOnExpiredRights:
        modules && modules.find((m) => m.name === 'blockDownloadOnExpiredRights')
          ? modules.find((m) => m.name === 'blockDownloadOnExpiredRights').activate
          : true,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { /*modulesWorkClient,*/ isIndividualComponent, modules } = this.props

    if (prevProps.modules !== modules && isIndividualComponent === false) {
      // const statusModules = []
      // const sendModules = []

      // if (!isIndividualComponent) {
      //   if (modules) {
      //     modules.forEach(permission => {
      //       if (permission.name === 'commentsAndVersions') {
      //         statusModules.push({ commentsAndVersions: permission.activate })
      //         sendModules.push({ name: 'commentsAndVersions', activate: permission.activate })
      //       }
      //     });
      //   } else {
      //     statusModules.push({ commentsAndVersions: false })
      //     sendModules.push({ name: 'commentsAndVersions', activate: false })
      //   }
      // } else {
      //   modulesWorkClient.forEach(permission => {
      //     if (permission.name === 'commentsAndVersions' && permission.activate === true) {
      //       statusModules.push({ commentsAndVersions: true })
      //       sendModules.push({ name: 'commentsAndVersions', activate: permission.activate })
      //     }
      //   });
      // }
      // this.setState(
      //   ...statusModules
      // )

      this.setState({
        commentsAndVersions:
          modules && modules.find((m) => m.name === 'commentsAndVersions')
            ? modules.find((m) => m.name === 'commentsAndVersions').activate
            : false,
        MFA:
          modules && modules.find((m) => m.name === 'MFA')
            ? modules.find((m) => m.name === 'MFA').activate
            : false,
        BunkeyHost:
          modules && modules.find((m) => m.name === 'BunkeyHost')
            ? modules.find((m) => m.name === 'BunkeyHost').activate
            : false,
        sistemasDeGrupos:
          modules && modules.find((m) => m.name === 'sistemasDeGrupos')
            ? modules.find((m) => m.name === 'sistemasDeGrupos').activate
            : false,
        useRights:
          modules && modules.find((m) => m.name === 'useRights')
            ? modules.find((m) => m.name === 'useRights').activate
            : false,
        blockDownloadOnExpiredRights:
          modules && modules.find((m) => m.name === 'blockDownloadOnExpiredRights')
            ? modules.find((m) => m.name === 'blockDownloadOnExpiredRights').activate
            : true,
      })
    }
  }


  handleActivate = (e) => {
    const { MFA, BunkeyHost, sistemasDeGrupos, useRights, blockDownloadOnExpiredRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'commentsAndVersions', activate: e.target.checked },
      { name: 'MFA', activate: MFA },
      { name: 'BunkeyHost', activate: BunkeyHost },
      { name: 'sistemasDeGrupos', activate: sistemasDeGrupos },
      { name: 'useRights', activate: useRights },
      { name: 'blockDownloadOnExpiredRights', activate: blockDownloadOnExpiredRights },
    ]
    this.props.handleSendModules(modules)
  }

  handleChange2FA = (e) => {
    const { commentsAndVersions, BunkeyHost, sistemasDeGrupos, useRights, blockDownloadOnExpiredRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'MFA', activate: e.target.checked },
      { name: 'commentsAndVersions', activate: commentsAndVersions },
      { name: 'BunkeyHost', activate: BunkeyHost },
      { name: 'sistemasDeGrupos', activate: sistemasDeGrupos },
      { name: 'useRights', activate: useRights },
      { name: 'blockDownloadOnExpiredRights', activate: blockDownloadOnExpiredRights },
    ]
    this.props.handleSendModules(modules)
  }

  handleChangeBunkeyHost = (e) => {
    const { commentsAndVersions, MFA, sistemasDeGrupos, useRights, blockDownloadOnExpiredRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'BunkeyHost', activate: e.target.checked },
      { name: 'commentsAndVersions', activate: commentsAndVersions },
      { name: 'MFA', activate: MFA },
      { name: 'sistemasDeGrupos', activate: sistemasDeGrupos },
      { name: 'useRights', activate: useRights },
      { name: 'blockDownloadOnExpiredRights', activate: blockDownloadOnExpiredRights },
    ]
    this.props.handleSendModules(modules)
  }

  handleChangesistemasDeGrupos = (e) => {
    const { commentsAndVersions, MFA, BunkeyHost, useRights, blockDownloadOnExpiredRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'BunkeyHost', activate: BunkeyHost },
      { name: 'commentsAndVersions', activate: commentsAndVersions },
      { name: 'MFA', activate: MFA },
      { name: 'sistemasDeGrupos', activate: e.target.checked },
      { name: 'useRights', activate: useRights },
      { name: 'blockDownloadOnExpiredRights', activate: blockDownloadOnExpiredRights },
    ]
    this.props.handleSendModules(modules)
  }

  handleChangeUseRights = (e) => {
    const { commentsAndVersions, MFA, BunkeyHost, sistemasDeGrupos, blockDownloadOnExpiredRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'BunkeyHost', activate: BunkeyHost },
      { name: 'commentsAndVersions', activate: commentsAndVersions },
      { name: 'MFA', activate: MFA },
      { name: 'sistemasDeGrupos', activate: sistemasDeGrupos },
      { name: 'useRights', activate: e.target.checked },
      { name: 'blockDownloadOnExpiredRights', activate: blockDownloadOnExpiredRights },
    ]
    this.props.handleSendModules(modules)
  }

  handleChangeBlockDownloadOnExpiredRights = (e) => {
    const { commentsAndVersions, MFA, BunkeyHost, sistemasDeGrupos, useRights } = this.state
    this.setState({ [e.target.value]: e.target.checked })
    const modules = [
      { name: 'BunkeyHost', activate: BunkeyHost },
      { name: 'commentsAndVersions', activate: commentsAndVersions },
      { name: 'MFA', activate: MFA },
      { name: 'sistemasDeGrupos', activate: sistemasDeGrupos },
      { name: 'useRights', activate: useRights },
      { name: 'blockDownloadOnExpiredRights', activate: e.target.checked },
    ]
    this.props.handleSendModules(modules)
  }


  render() {
    const { intl, newColor, isIndividualComponent = true } = this.props
    const { commentsAndVersions, MFA, BunkeyHost, sistemasDeGrupos, useRights, blockDownloadOnExpiredRights } = this.state
    return (
      <div>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>{intl.formatMessage({ id: "module_comment_and_versions" })}  </b> </span>
          <Checkbox onChange={this.handleActivate} checked={commentsAndVersions} value='commentsAndVersions' ></Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>{intl.formatMessage({ id: "MFA" })}  </b> </span>
          <Checkbox onChange={this.handleChange2FA} checked={MFA} value='MFA' ></Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>Bunkey Host  </b> </span>
          <Checkbox onChange={this.handleChangeBunkeyHost} checked={BunkeyHost} value='BunkeyHost' ></Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>Sistema Grupos  </b> </span>
          <Checkbox onChange={this.handleChangesistemasDeGrupos} checked={sistemasDeGrupos} value='sistemasDeGrupos' ></Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>Derechos de uso de contenidos  </b> </span>
          <Checkbox onChange={this.handleChangeUseRights} checked={useRights} value='useRights' ></Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '5px' }}>
          <span><b>Bloquear descarga con derechos vencidos  </b> </span>
          <Checkbox
            onChange={this.handleChangeBlockDownloadOnExpiredRights}
            checked={blockDownloadOnExpiredRights}
            value='blockDownloadOnExpiredRights'
            disabled={!useRights}
          ></Checkbox>
          {!useRights && (
            <small style={{ display: 'block', opacity: 0.65 }}>
              {intl.formatMessage({ id: "rights_block_download_requires_module" })}
            </small>
          )}
        </Form.Item>

        {isIndividualComponent &&
          <Form.Item>
            <Button
              type='deafult'
              style={{ color: newColor, borderColor: newColor }}
              onClick={this.handleActivateModules}>
              {intl.formatMessage({ id: "module_activate" })}/{intl.formatMessage({ id: "module_deactivate" })}
              <Icon type="check-circle" /></Button>
          </Form.Item>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  workclient: state.client.workclient,
  modulesWorkClient: state.client.data ? state.client.data.modules : [],
})

const mapDispatchToProps = {
  activateModules
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivationModules)))
